import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=65a0c6fe&scoped=true&"
import script from "./seckill.vue?vue&type=script&lang=js&"
export * from "./seckill.vue?vue&type=script&lang=js&"
import style0 from "./seckill.vue?vue&type=style&index=0&id=65a0c6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0c6fe",
  null
  
)

component.options.__file = "seckill.vue"
export default component.exports